<section class="content">
  <h1>Auswertungen</h1>
  <p>Klicken Sie auf die jeweilige Schaltfläche, um die Details der Einzelaufstellung anzuzeigen.</p>

  @if (isLoading()) {
    <div class="alert alert-info">
      <p>Laden Daten...</p>
    </div>
  }

  @if (hasError()) {
    <div class="red">
      <p><strong>Fehler:</strong> Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.</p>
    </div>
  }

  @if (!isLoading() && !hasError()) {
    <form>
      <mat-form-field appearance="outline" class="my-l col-4">
        <mat-label>Monat</mat-label>
        <mat-select (selectionChange)="onMonthSelect($event)" [value]="selectedMonth()">
          @for (month of months; track month; let i = $index) {
            <mat-option [value]="i">{{ month.full }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>

    <div class="evaluations-grid">

      @if (goodwill().visible) {
        <div class="tile" (click)="showDetails('1')">
          <div class="text-xlarge text-hb">{{ sum().goodwill | currency:'EUR':'symbol':'1.2-2' }}</div>
          @if (evaluations(); as eval) {
            <div>Summe {{ eval.month }}/{{ eval.year }}</div>
          }
          <h4>Kulanzen</h4>
        </div>
      }

      @if (assortment().assortment_rx.visible || assortment().assortment_non_rx.visible) {
        <div class="tile" (click)="showDetails('2')">
          <div class="text-xlarge text-hb">{{ sum().assortment | currency:'EUR':'symbol':'1.2-2' }}</div>
          @if (evaluations(); as eval) {
            <div>Summe {{ eval.month }}/{{ eval.year }}</div>
          }
          <h4>Servicesortimente</h4>
        </div>
      }

      @if (revenue().visible) {
        <div class="tile" (click)="showDetails('3')">
          <div class="text-xlarge text-hb">{{ sum().revenue | currency:'EUR':'symbol':'1.2-2' }}</div>
          @if (evaluations(); as eval) {
            <div>Summe {{ eval.month }}/{{ eval.year }}</div>
          }
          <h4>Umsätze und Packungen</h4>
        </div>
      }

      @if (fees().fees_general.visible || fees().fees_returns.visible) {
        <div class="tile" (click)="showDetails('4')">
          <div class="text-xlarge text-hb">{{ sum().fees | currency:'EUR':'symbol':'1.2-2' }}</div>
          @if (evaluations(); as eval) {
            <div>Summe {{ eval.month }}/{{ eval.year }}</div>
          }
          <h4>Gebühren</h4>
        </div>
      }

    </div>
  }
</section>

@if (chosenDetails() && !isLoading() && !hasError()) {
  <section class="content">

    @switch (chosenDetails()) {
      @case ('1') {
        @if (goodwill().visible) {
          <div>
            <h2 class="mt-0">Einzelaufstellung Kulanzen</h2>
            <p>
              In dieser Übersicht werden Ihnen alle angefallenen Einzelpositionen aufgezeigt.
              Den Gesamtbetrag (Summe) "Kulanzen" finden Sie ebenfalls in der Kaufstruktur des
              jeweiligen Monats wieder.
            </p>

            @if (goodwill().sum === 0) {
              <p class="mt-l"><strong>In diesem Monat sind keine Kulanzen angefallen.</strong></p>
            } @else {
              <app-eval-table
                [data]="goodwillRows()"
                [columns]="goodwillColumns"
                [sumRow]="goodwillSum()">
              </app-eval-table>
            }
          </div>
        }
      }

      @case ('2') {
        @if (assortment().assortment_non_rx.visible || assortment().assortment_rx.visible) {
          <div>
            <h2 class="mt-0">Einzelaufstellung Servicesortimente</h2>
            <p>In dieser Übersicht werden Ihnen alle bezogenen Servicesortimente separat mit Umsatz
              und Packungszahl angezeigt.</p>

            @if (assortment().assortment_rx.visible) {
              <app-eval-table
                [data]="assortmentRxRows()"
                [columns]="assortmentRxColumns"
                [sumRow]="assortmentRxSum()">
              </app-eval-table>
            }

            @if (assortment().assortment_non_rx.visible) {
              <app-eval-table
                [data]="assortmentNonRxRows()"
                [columns]="assortmentNonRxColumns"
                [sumRow]="assortmentNonRxSum()">
              </app-eval-table>
            }
          </div>
        }
      }

      @case ('3') {
        @if (revenue().visible) {
          <div>
            <h2 class="mt-0">Einzelaufstellung Umsätze und Packungen (Gesamt)</h2>
            <p>In dieser Übersicht werden Ihnen die Gesamtumsätze sowie die jeweilige Packungsanzahl
              in den einzelnen Bereichen RX, RX-Hochpreis und Non-RX angezeigt.</p>

            <app-eval-table
              [data]="revenueRows()"
              [columns]="revenueColumns"
              [sumRow]="revenueSums()">
            </app-eval-table>
          </div>
        }
      }

      @case ('4') {
        @if (fees().fees_returns.visible || fees().fees_general.visible) {
          <div>
            <h2 class="mt-0">Einzelaufstellung Gebühren</h2>
            <p>In dieser Übersicht wird Ihnen die Zusammensetzung der erhobenen Gebühren angezeigt.</p>

            @if (fees().fees_general.visible) {
              <app-eval-table
                [data]="feesGeneralRows()"
                [columns]="feesGeneralColumns"
                [sumRow]="feesGeneralSum()">
              </app-eval-table>
            }

            @if (fees().fees_returns.visible) {
              <app-eval-table
                class="mt-xl"
                [data]="feesReturnsRows()"
                [columns]="feesReturnsColumns"
                [sumRow]="feesReturnsSum()">
              </app-eval-table>
            }
          </div>
        }
      }
    }
  </section>
}
